import React, { useEffect, useState } from "react";
import { MainWrapper } from "app/pages/individual/component/MainWrapper";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { FormattedMessage } from "react-intl";
import { getStripeTransactions } from "sr/utils/api/strip/getStripeTransactions";
import { Pagination } from "app/pages/component/Pagination";
import { TransactionsTable } from "app/pages/component/TransactionsTable";

export const IndividualMyTransactions = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<any>(null);
  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      const queryParams = new URLSearchParams();
      queryParams.append("limit", String(limit));
      queryParams.append("page", String(page));
      const res = await getStripeTransactions(queryParams.toString());
      setRows(Array.isArray(res?.data) ? res.data : []);
      setPagination(res?.pagination || null);
      setLoading(false);
    };
    fetchTransactions();
  }, [limit, page]);

  const total = Number(pagination?.total || 0);
  const pageSize = Number(pagination?.pageSize || limit);
  const totalPage =
    total && pageSize ? Math.max(1, Math.ceil(total / pageSize)) : 1;

  return (
    <MainWrapper>
      <div className="py-3">
        <div className="mb-2">
          <h1 className="text-2xl border-r border-neutral-200 pr-4">
            <FormattedMessage
              id="INDIVIDUAL.TRANSACTIONS.TITLE"
              defaultMessage="My Transactions"
            />
            {Number.isFinite(total) ? (
              <span className="text-neutral-500">
                {" "}
                ({total})
              </span>
            ) : null}
          </h1>
        </div>

        <ContentWithSpinner loader={loading} height="h-screen">
          <div className="bg-white rounded-lg p-5 border border-neutral-200">
            <TransactionsTable rows={rows} mode="payer" titleLabel="Job" />

            {totalPage > 1 ? (
              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
            ) : null}
          </div>
        </ContentWithSpinner>
      </div>
    </MainWrapper>
  );
};
